import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ColumnModel } from "@syncfusion/ej2-vue-grids";
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import BaseGridView from "../../common/BaseGridView.Component.vue";
import { SearchOption, TemplateDef } from "../../common/CommonInterfaces";
import { GridConfig } from "../../common/Constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactPersonComponent',
  setup(__props) {

let columnDef = ref([] as ColumnModel[]);
const _searchOptions = {
  fields: [
    "company.Name",
    "firstName",
    "lastName",
    "emailAddress",
    "createdDateTimeOffset",
    "lastChangedDateTimeOffset",
    "title",
  ],
  operator: "contains",
  ignoreCase: true,
} as SearchOption;

const templateDef: TemplateDef = {
  prefix: "contactPerson",
  columnNames: ["isActive"],
};

const app = getCurrentInstance();

onBeforeMount(() => {
  assignColumnDef();
});

const assignColumnDef = () => {
  const instance = app?.proxy;
  columnDef.value = [
    {
      field: "companyName",
      headerText: instance?.$t("companyName"),
      textAlign: "Center",
      width: 200,

    },
    { field: "firstName", headerText: instance?.$t("firstName") },
    { field: "lastName", headerText: instance?.$t("lastName") },
    {
      field: "isActive",
      headerText: instance?.$t("status"),
      template: "contactPerson_isActive",
    },
    { field: "emailAddress", headerText: instance?.$t("emailAddress") },
    {
      field: "createdDateTimeOffset",
      headerText: instance?.$t("createdDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    {
      field: "lastChangedDateTimeOffset",
      headerText: instance?.$t("lastChangedDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    { field: "title", headerText: instance?.$t("title") },
  ];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseGridView, {
    endpoint: "v1/ContactPerson/GetData",
    pageTitle: _ctx.$t('Contact Persons'),
    columnDef: (_unref(columnDef) as Array<ColumnModel>),
    searchOptions: _searchOptions,
    templateDef: templateDef
  }, {
    contactPerson_isActive: _withCtx(({ rowData }) => [
      _createElementVNode("span", {
        class: _normalizeClass(rowData.value ? 'badge text-bg-success' : 'badge text-bg-danger')
      }, _toDisplayString(rowData.value ? "Active" : "Inactive"), 3)
    ]),
    _: 1
  }, 8, ["pageTitle", "columnDef"]))
}
}

})